import React from 'react';
import { Outlet } from 'react-router-dom';

const Error = () => {
  return <Outlet />;
};

export default Error;
